var LeadServicePresenter = /** @class */ (function () {
    function LeadServicePresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    LeadServicePresenter.prototype.leadsSearch = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.searchLead.execute({
                onSuccess: function (data) {
                    _this.actions.searchLead(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    LeadServicePresenter.prototype.sbSearch = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.sbSearch.execute({
                onSuccess: function (data) {
                    _this.actions.sbSearch(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    LeadServicePresenter.prototype.partnerLead = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.partnerLead.execute({
                onSuccess: function (data) {
                    _this.actions.partnerLead(data);
                    resolve(data);
                },
                onError: function (error) {
                    _this.actions.setError({
                        isOpen: true,
                        error: error,
                    });
                    reject(error);
                },
            }, req);
        });
    };
    LeadServicePresenter.prototype.updatePartnerLead = function (req) {
        this.actions.partnerLead(req);
    };
    LeadServicePresenter.prototype.updatePartnerSlot = function (req) {
        this.actions.updatePartnerSlot(req);
    };
    return LeadServicePresenter;
}());
export default LeadServicePresenter;
